import * as yup from 'yup';



export interface GroupEditorValues {
	// id: number
	name: string;
	// photo: FileList | string;

}

export const shema = yup.object().shape({
	name: yup
		.string()
		.required('Укажите название группы')
		.min(1, 'Слишком короткое название'),
	 
});

// export const groupUpdateSchema = yup.object().shape({
// 	name: yup
// 		.string()
// 		.required('Укажите название группы')
// 		.min(3, 'Слишком короткое название'),
// 	// photo: yup.mixed().required('Загрузите обложку'),

// });
